import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../../SectionHeading';

const HumanScaleRo = () => (
  <section className="py-24 bg-brand-dark border-t border-white/5">
    <div className="max-w-5xl mx-auto px-6 lg:px-8">
      <SectionHeading title="Inima Cronicii" subtitle="Scara Umană" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
        <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
          <p className="text-gray-300 leading-relaxed text-lg mb-6">
            Ceea ce ridică această carte deasupra science fiction-ului obișnuit este insistența sa asupra scării umane. Printre operațiunile de terraformare și motoarele cu antimaterie, autorul ne oferă <span className="text-white">conversații la micul dejun, înotul de dimineață în oceane bioluminescente</span> și fiice care se tem în liniște că nu sunt suficient de pregătite pentru a pleca spre stele.
          </p>
          <p className="text-gray-400 leading-relaxed">
            Urmărim linii familiale multi-generaționale — Vasquez, Tanaka, Osei-Okonkwo, Rivera-Mwangi — de-a lungul secolelor, observând cum curajul sau lașitatea unei persoane se răsfrânge asupra urmașilor care nu i-au cunoscut niciodată.
          </p>
        </motion.div>
        <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="space-y-6">
          <div className="bg-brand-surface border border-white/5 rounded-2xl p-6">
            <p className="text-gray-300 italic leading-relaxed text-sm">
              "Celeste Moreau-Bouazizi, înotând în oceanele venusiene formate din gheață jovienă topită, onorează durerea străbunicului ei care a jelit distrugerea vechiului Venus — chiar în timp ce celebrează lumea care l-a înlocuit."
            </p>
          </div>
          <div className="bg-brand-surface border border-white/5 rounded-2xl p-6">
            <p className="text-gray-300 italic leading-relaxed text-sm">
              "Eseosa Rivera-Mwangi, directoarea Observatorului Heliopausei din Neptun, îi ține mâna fiicei sale într-un coridor rece și vorbește în felul neptunian reținut despre ce înseamnă să duci vocea unei civilizații în întuneric."
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);

export default HumanScaleRo;